const d = function* (e, t) {
  let n = e.byteLength;
  if (n < t) {
    yield e;
    return;
  }
  let a = 0, r;
  for (; a < n; )
    r = a + t, yield e.slice(a, r), a = r;
}, h = async function* (e, t) {
  for await (const n of w(e))
    yield* d(n, t);
}, w = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const t = e.getReader();
  try {
    for (; ; ) {
      const { done: n, value: a } = await t.read();
      if (n)
        break;
      yield a;
    }
  } finally {
    await t.cancel();
  }
}, b = (e, t, n, a) => {
  const r = h(e, t);
  let y = 0, o, l = (c) => {
    o || (o = !0, a && a(c));
  };
  return new ReadableStream({
    async pull(c) {
      try {
        const { done: i, value: s } = await r.next();
        if (i) {
          l(), c.close();
          return;
        }
        let u = s.byteLength;
        if (n) {
          let f = y += u;
          n(f);
        }
        c.enqueue(new Uint8Array(s));
      } catch (i) {
        throw l(i), i;
      }
    },
    cancel(c) {
      return l(c), r.return();
    }
  }, {
    highWaterMark: 2
  });
};
export {
  h as readBytes,
  d as streamChunk,
  b as trackStream
};
//# sourceMappingURL=index.es179.js.map
